<template lang="pug">
.features.features-home.stats-page
  input#current_explorer(type='hidden')
  input#current_coin(type='hidden')

  GenerateQR(
    v-if="showQR"
    @close="showQR = false"
    :address="addressFromDB"
    :memo="memo"
  )

  ConnectionId(
    v-if="showConnectionId"
    @close="showConnectionId = false"
    :connectionId="connectionId"
    :address="getFormattedAddressShort(addressFromDB)"
    :memo="memo"
    :coin="coin"
  )

  .columns
    .column.col-result.first-col-result.is-full(v-if="showSearch")
      //- .features.address-info(v-if="!addressFound && !isLoadingSameAddress")
      .features.address-info
        .start-info
          .title-mining 
            span.pink View 
            span  your 
            coin-switcher(
              :hintTop="true"
              @selected="selectCoinFromSwitcher"
              :class="{ 'no-pointer-events': noPointerEvents }"
            )
            span  stats
      .features.address-info(v-if="newCoins.length || recentCoins.length > 1")
        span.fs-14.recent-item-el Or search on
        .newest-list
          .new-coin.hint--bottom-right(v-for="i in recentCoins", :aria-label="i.name + ' (' + i.symbol + ')'", @click="selectNewCoin(i)", v-if="i.symbol != coin", :class="{ 'is-loading': loadingCoin === i.symbol }")
            .new-tag(v-if="i.top === 1")
            .new-coin-loading(v-if="loadingCoin === i.symbol")
              i.fa.fa-circle-o-notch.fa-spin
            .new-coin-logo
              img(:src="i.logo")
          .new-coin-separator(v-if="newCoins.length && recentCoins.length > 1")
          .new-coin.hint--bottom-right(v-for="i in newCoins", :aria-label="i.name + ' (' + i.symbol + ')'", @click="selectNewCoin(i)", v-if="i.symbol != coin", :class="{ 'is-loading': loadingCoin === i.symbol }")
            .new-tag(v-if="i.top === 1")
            .new-coin-loading(v-if="loadingCoin === i.symbol")
              i.fa.fa-circle-o-notch.fa-spin
            .new-coin-logo
              img(:src="i.logo")
            //- .new-coin-name
              span {{ i.symbol }}
          .new-coin.view-all.recent-item-el(@click="openCoinSwitcher()")
            span View all
            i.fa.fa-arrow-right
      .features.address-info.mt-20
        .filter-label
          span Enter your address:
        .field.field-address.has-addons.position-relative.address-search-field
          .control.is-medium.is-expanded.position-relative(:class="{'is-loading': isFindingAddress}")
            input.input.is-medium#address_input(
              type="text" 
              :placeholder="'Your ' + coin + ' address'"
              v-model="address"
              :disabled="isFindingAddress || disableInput || loadingCoin != ''"
              @keyup.enter="findAddressPre"
              autocomplete="off"
              spellcheck="false"
            )
          .control#find_address.button-address-container
            a.button.is-success.is-medium.button-address(@click="findAddressPre", :disabled="isFindingAddress || disableInput || loadingCoin != ''", :class="{ 'no-pointer-events': noPointerEvents }")
              i.fa.fa-search
        .label-info-memo.mb-15.addon(v-if="isMemoCoin")
          span If you are using an exchange address that requires a payment tag or memo search 
          span.w400  YourAddress
          b(style='margin: 0px 1.5px;') :
          span.w400 YourMemo
        template(v-if="listOfLastAddresses.length > 0")
          template(v-if="listOfCoins.length > 1")
            .filter-label
              span Filter your 
              span.w400 search history 
              span  by coin or token 
            coin-filter(
              @selected="toggleFilterCoin"
              :listOfCoins="listOfCoins"
              :class="{ 'no-pointer-events': noPointerEvents }"
            )
          .columns.is-multiline.is-mobile
            .column.is-half-tablet.is-half-desktop.is-one-third-widescreen.is-one-third-fullhd.is-one-mobile(v-for="o, index in listOfLastAddresses")
              .prev-address
                .box(@click="selectAddressFromFinder(o)", :class="{ 'no-pointer-events': noPointerEvents }")
                  figure.image
                    img(:src="o.coinLogo", :alt="o.coin + ' logo'")
                  .content
                    .content-address
                      strong.long {{ o.formattedAddress || o.address }} 
                      strong.medium {{ o.formattedAddressMedium || o.address }} 
                      strong.short {{ o.formattedAddressShort || o.address }} 
                    .content-balance
                      .fs-12 Balance 
                      .count-up-balance
                        //- template(v-if="o.uuid && typeof o.balance === 'number'")
                        template(v-if="o.uuid && o.balance")
                          span(:class="{'animate-long': o.animate}") {{ o.balance }}
                        template(v-else)
                          span ***
                    .content-last(v-if="reloadLastViewed")
                      span(v-if="o.updated") Updated {{ o.updated | fromNow }}
                      span(v-else) Not yet mining
                  .remove.hint--top-left(aria-label="Remove from the history" @click.stop="removeAddressFromLastAddress(o, index)")
                    i.fa.fa-times

    //- .column.is-two-thirds.col-result(v-show="addressFound || isLoadingSameAddress")
    .column.col-result(v-show="!showSearch && !isMissingMemo")
      button.button.button-back-search(@click="closeCurrentAddress()")
        img.chevron(:src="'/img/icons/left-chevron-' + mode +  '.svg'", alt="Scroll right")
        span Back
      template(v-if="lastAddressesCoin.length")
        button.button.button-back-search.address-history(v-for="item in lastAddressesCoin", @click="selectAddressFromPrevious(item)") 
          img(:src="item.coinLogo", :alt="item.coin + ' logo'")
          span {{ isMobile ? item.formattedAddressShort : item.formattedAddressMedium }}
      .button.button-back-search.address-history.button-coin-inline
        coin-switcher(
          :compact="true"
          @selected="selectCoinFromCompactSwitcher"
          :class="{ 'no-pointer-events': noPointerEvents }"
        )
      button.button.button-back-search.address-history.quick-search(
          onclick="document.getElementById('quick').focus()"
          :class="{ 'loading-quick': isFindingAddress || disableInput || loadingCoin != '', 'hint--always': showAlwaysReload, 'hint--right': !isMobile, 'hint--bottom': isMobile }",
          :aria-label="'Search ' + (('aeiou'.split('').indexOf((preCoin[0]).toLowerCase()) > -1) ? 'an' : 'a') + ' ' + preCoin + ' address!'"
        )
        input.input.is-small#quick(
          v-model="addressQuickSearch"
          @keyup.enter="findAddressPreQuick"
          placeholder="Quick search"
          :disabled="isFindingAddress || disableInput || loadingCoin != ''"
          autocomplete="off",
          :class="{ 'searching': addressQuickSearch }"
        )
        i.fa.fa-search.search-icon(@click="findAddressPreQuick", :class="{ 'searching': addressQuickSearch }")
      .result-address
        .info-miner.w100.pos-r.padding-container.has-text-left
          .big-info.main
            div.is-flex.aic.balance-container
              .flex-1
                span.fw-400 Balance 
                template(v-if="!inactiveAccount")
                  span.animated-circle.hint--bottom-right(aria-label="Updating in real-time")
                template(v-else)
                  span.animated-circle.inactive.hint--bottom-right.hint--large(:class="{ 'hint--always': showAlwaysInactivity || showAlwaysReload }", aria-label="Your account is currently inactive. It will be cleared from our records after 6 months of no activity. For more information, please review our Terms & Conditions in the Support section.")

                span.top-option
                  span.top-option-text(v-if="miningFee == '0.75'") 0.75% 
                  span.top-option-text(v-else) 1% 
                  span.top-option-text mining fee 
                  span.top-option-text.top-fee-disclaimer.hint--bottom-right.has-text-left.fw-400.hint--show-mobile(v-if="miningFee == '0.75'", aria-label='Fee lowered for using a valid referral code!')
                    i.fa.fa-info-circle
                  span.top-option-text.top-fee-disclaimer.hint--bottom.has-text-left.hint--medium.fw-400.hint--show-mobile(v-else, aria-label='Lower your fee by using a referral code in at least one worker!')
                    i.fa.fa-info-circle

                span.top-option
                  span.top-option-text {{ network }} 
                  span.top-option-text chain 
                  span.top-option-text.top-fee-disclaimer.hint--bottom-right.has-text-left.hint--large.fw-400.hint--show-mobile(
                    aria-label='We support multiple payout chains for this coin / token. If you are switching between compatible chains, double check that you can receive your coins to the same exact address on the chain that you choose, otherwise you will lose your funds when processing a payout. You can also benefit from lower payment thresholds when using different chains.'
                    v-if="chains.length > 1"
                  )
                    i.fa.fa-info-circle


                .big-info-number.balance(:class="{'is-loading': isFindingAddress && balance === 0}", key="balance-number")
                  .min-height-balance
                    count-up.count-up-balance(
                      :endVal="+balance",
                      :options="countUpAmountOptions"
                      :style="calculatedBalanceFontSize ? 'font-size:' + calculatedBalanceFontSize + 'px' : ''"
                      :class="{'large-amount': balance && balance.indexOf('.') > 6}"
                      v-if="forceReRender"
                    )
                    //- .count-up-balance(
                    //-   :class="{'large-amount': balance && balance.indexOf('.') > 6}"
                    //-   :style="calculatedBalanceFontSize ? 'font-size:' + calculatedBalanceFontSize + 'px' : ''"
                    //- ) {{ balance }}
                    img(:src="coinLogo", :alt="coin + ' logo'")
            .current-address-view
              span Address  
              span.address_.hint--top(
                @click="copyToClipboard(addressFromDB, 'address')"
                :aria-label="'Click to copy!'"
              )
                | {{ trimmedAddress }}
              .is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd(v-if="memo")
              span(v-if="memo")  Memo  
              span.address_.hint--top(
                v-if="memo"
                @click="copyToClipboard(memo, 'memo or payment tag')"
                :aria-label="'Click to copy!'"
              )
                | {{ trimmedMemo }}
              a.reload-control.is-hidden-mobile.hint--top(
                v-if="selectedChain.explorer_address" 
                :href="selectedChain.explorer_address_link" 
                target="_blank"
                aria-label="View on public explorer"
              )
                i.fa.fa-external-link
              span.reload-control.is-hidden-mobile.hint--bottom-left(
                @click="openConnectionId"
                aria-label="Use your Mining Key to simplify your mining setup"
                :class="{ 'hint--always': showAlwaysReload }"
              )
                i.fa.fa-key
              span.reload-control.is-hidden-mobile.hint--top(
                @click="generateQR"
                aria-label="Generate a QR code / View full address"
              )
                i.fa.fa-qrcode
              span.reload-control.is-hidden-mobile.hint--right(
                @click="reloadStats"
                aria-label="Reload Stats"
                :class="{ 'hint--always': showAlwaysReload }"
              )
                i.fa.fa-refresh(:class="{ 'fa-spin': isFindingAddress }")
            TransitionGroup(name="slide")
              .pay-block(v-if="!isOpenPayingOutNow && !isOpenSwitchingNetwork", key="buttons")
                button.button.is-normal.is-info#pre_do_pay(
                  :disabled="hasPayoutNowDisabled"
                  :aria-label="messageCanNotPayoutNow"
                  :class="{'hint--top': hasPayoutNowDisabled}"
                  @click="openPayoutNow"
                  v-if="!(!isEnabled && isEnabledOnlyAutomatic)"
                ) Payout now  
                button.button.is-normal.is-warning#pre_switch_network(
                  v-if="chains.length > 1"
                  @click="openSwitchNetwork"
                ) Switch network
                a.is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd(v-if="selectedChain.explorer_address" :href="selectedChain.explorer_address_link" target="_blank")
                  button.button.is-normal.is-default#go-to-explorer 
                    | View on explorer  
                    i.fa.fa-external-link.fs-12.mt-5.ml-5
                a.is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd(
                  @click="openConnectionId"
                )
                  button.button.is-normal.is-default#go-to-explorer 
                    | View your Key
                    i.fa.fa-key.fs-13.mt-1.ml-5
                button.button.is-normal.is-light.is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd.hint--top(
                  @click="generateQR"
                  aria-label="To scan it in our monitoring app"
                )
                  | Show QR
                  i.fa.fa-qrcode.fs-14.ml-5.mt-3
                a.is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd(@click="findAddressPre")
                  button.button.is-normal.is-default#go-to-explorer 
                    | Reload Stats
                    i.fa.fa-refresh.fs-12.mt-2.ml-5(:class="{ 'fa-spin': isFindingAddress }")

              .confirm-pay-block(v-if="isOpenPayingOutNow", key="confirm-pay")
                div
                  span You will receive
                  span &nbsp;
                  b.light-bold#payable_balance {{ balancePayable }}
                  b.light-bold  {{ coin }}
                  template(v-if="chains.length > 1")
                    span.top-network-selected  through the  
                    b.top-network-selected.light-bold.multi-chain-current-long  {{ selectedChain.name }} ({{ selectedChain.token_standard }})
                    span.top-network-selected  network.
                .end
                  span A manual payout  
                  b.light-bold can be asked once a day (starting at 00:00 UTC)
                button.button.is-normal.is-success#do_pay(
                  @click="doPayout"
                  :class="{'is-loading': isPayingOutNow}"
                  :disabled="isPayingOutNow"
                ) Yes, continue
                button.button.is-normal.is-default#cancel_pay(@click="isOpenPayingOutNow = false") No

              .confirm-switch-network(v-if="isOpenSwitchingNetwork", key="confirm-switch")
                .w400
                  span If you are switching between compatible chains, make sure that your wallet has support for the chain you are selecting, and that it reuses the same address (if the address is different, you will lose your funds).
                .w400.mt-10
                  span If you are mining to an exchange, double check that your exchange reuses the same address for the network that you are selecting.
                .w400.s12.mt-10
                  u In any case, please make sure that you can receive your coins to the same exact address on the new network (chain) you are switching to, otherwise you will lose your funds.
                .w400.s12.mt-10
                  span Also note that 
                  b your balance will remain unchanged (it will not reset to zero) whenever you switch your payout network.
                .w400.mt-10
                  span Kindly read carefully  
                  a.s12(href='https://unmineable.com/support/article/what-is-multi-chain-support-and-how-to-use-it/') 
                    b our support center article  
                    i.fa.fa-external-link  
                  span , to prevent losing any funds when processing your next payout.
                .w400.mt-10
                  span Switching networks is instant and your next payout will be sent through the new network.
                .network-selector.mt-10

                  .network-item(v-for="item in chains")
                    .network-name.w400 {{ item.name }} ({{ item.network }})
                    .network-token {{ item.token_standard }}
                    .network-feature
                      span Payment threshold: 
                      span.w400 {{ item.payment_threshold }}
                    .network-feature
                      span Payment status: 
                      span.w400 
                        template(v-if="item.enabled") Enabled
                        template(v-else) Maintenance
                    .network-feature(v-if="item.contract")
                      span Contract: 
                      a.w400(
                        :href="item.explorer_address + item.contract" 
                        target="_blank" 
                        ) {{ item.contract.substring(0, 5) }}...{{ item.contract.substring(item.contract.length - 5) }}
                    .confirm-block-network(v-if="isConfirmingSwitchNetwork && item.network === selectedChainToSwitch.network") Before continuing, double check that you have access to the exact same address on the {{ item.network }} network, otherwise you may lose your mined funds on the next payout. If you are using an exchange double check that it reuses the same address for the {{ item.network }} network.
                      .button-selector.has-text-right
                        a.button.is-default.is-small.cancel-confirm-network(@click="cancelConfirmingSwitchNetwork") Cancel
                        a.button.is-success.is-small.do-switch-network(
                          :data-network="item.network"
                          @click="doSwitchNetwork(item)"
                          :class="{'is-loading': isSwitchingNetwork}"
                          :disabled="isSwitchingNetwork"
                        ) Continue
                    .button-selector.button-selector-pre.has-text-right(v-if="!(isConfirmingSwitchNetwork && item.network === selectedChainToSwitch.network)")
                      a.button.is-default.is-small.hint--top.text-black-on-dark(
                        :aria-label="'Check your address on a ' + item.network + ' explorer.'"
                        :href="item.explorer_address_link" 
                        target="_blank"
                        v-if="item.compatible"
                      ) Explorer 
                        i.fa.fa-external-link
                      a.button.is-success.is-small.hint--top(
                        aria-label="Current network", 
                        disabled,
                        v-if="item.network === selectedChain.network && item.compatible"
                      ) Use
                      a.button.show-confirm-network.is-success.is-small(
                        v-if="item.network !== selectedChain.network && item.compatible"
                        @click="confirmingSwitchNetwork(item)"
                      ) Use
                      a.button.is-success.is-small.hint--top(
                        v-if="!item.compatible"
                        disabled, 
                        aria-label="Non-compatible network"
                      ) Use

                button.button.is-normal.is-default#cancel_switch(@click="isOpenSwitchingNetwork = false") Go back

              div.mt-10(
                key="only-automatic-message"
                v-if="!isEnabled && isEnabledOnlyAutomatic"
              )
                span Payouts for 
                strong {{ coin }} 
                span are processed automatically once a day. Be sure to set your auto-payout setting to On!

              .autopay-switch-block(key="autopay")

                label.checkbox
                  span.switch-
                    input#setting-auto_pay(type='checkbox', v-model="autoPay", @change="doChangeAutoPay")
                    .slider-.round-
                  span
                    span  Auto pay  
                    b.light-bold once a day (at 01:00 UTC)  
                    span whenever my balance is over  
                    b.light-bold.threshold_amount {{ paymentThreshold | thousandComma }} 
                    span  
                    b.light-bold {{ coin }}
                    .hint--top-left.hint--large.has-text-left.cursor-pointer.autopay-message(
                      aria-label='You must receive at least one reward on the past UTC day for your auto payment to be processed.'
                    ) 
                      i.fa.fa-info-circle.ml-5

      //- news(
      //-   :pinnedOnly="true"
      //-   :inStats="true"
      //- )
      stat-notification(
          v-if="uuid"
          :chain="selectedChain"
          :address="address"
          :chains="chains"
          :isMissingMemo="isMissingMemo"
          :hasPaymentError="hasPaymentError"
          :isRestricted="isRestricted"
          :isEnabled="isEnabled"
          :isEnabledOnlyAutomatic="isEnabledOnlyAutomatic"
          :isDelisted="isDelisted"
          :isFresh="isFresh"
          :isNotActivated="isNotActivated"
          :hasNoWorkers="hasNoWorkers"
          :addressFromDB="addressFromDB"
          :maintenanceMessage="maintenanceMessage"
        )

      tab-option(
        :selectedTab="selectedTab"
        @selected="changeTab"
        :hasCustomCode="hasCustomCode"
      )

      .tab-content(
        :class="{'is-loading': isLoadingHub}"
        v-show="selectedTab.code === 'hub'"
      )
        .fs-16.text-white-on-dark.pb-5.pt-20
          b Spotlight
        Slider(:slides="tileBlocks.length")
          .slide-box.has-text-left.slide(v-for="b in tileBlocks")
            .tile.is-ancestor
              a.tile.is-parent(v-for="o in b", :href="o.link", target="_blank")
                article.tile.is-child.box
                  p.title.is-spaced {{ o.title }}
                  p.subtitle 
                    span {{ o.subtitle }}
                    template(v-if="o.link")
                      span &nbsp;
                      i.fa.fa-external-link
        .columns
          .column.is-half
            news(
              :inStats="true",
              :countOverride="4"
            )
          .column.is-half
            PlatformStats
            .info-miner.w100
              hr
              p If you have any issue, question or suggestion contact us here:
              br
              .mb-10
                div Email (Official Support Channel)
                a.social-link(href='mailto:support@unmineable.com')
                  b support@unmineable.com
              .mb-10
                div X (formerly Twitter)
                a.social-link(href='https://x.com/un_mineable', target='_blank')
                  b @un_mineable
              .mb-10
                div Instagram
                a.social-link(href='https://instagram.com/unminable', target='_blank')
                  b @unminable
              .mt-15
                span Beware of impersonators, we have no official Telegram or Discord channels.
      .tab-content(
        :class="{'is-loading': isLoadingWorkersData}"
        v-show="selectedTab.code === 'workers'"
      )
        .result-address
          .result-no-workers.pos-r.has-text-left.padding-workers.text-white-on-dark(v-if="hasNoWorkers")
            span You have no workers online.
            br
            br
            span.w400 TIP:  
            span  You can mine different algorithms at the same time, with different worker names.

        tab-workers(
          :uuid='uuid'
          ref="workerstab"
          @hasNoWorkers="hasNoWorkers = true"
          @hasWorkers="hasNoWorkers = false"
          @startLoading="isLoadingWorkersData = true"
          @stopLoading="isLoadingWorkersData = false"
        )

      .tab-content(
        :class="{'is-loading': isLoadingLiveData}"
        v-if="selectedTab.code === 'live' && uuid"
      )
        .columns
          .column
            .result-address
              tab-live(
                :uuid='uuid'
                :summary='summary'
                ref="livetab"
                @startLoading="isLoadingLiveData = true"
                @stopLoading="isLoadingLiveData = false"
                @goToTab="changeTab"
              )

      .tab-content(
        :class="{'is-loading': isLoadingPaymentsData}"
        v-if="selectedTab.code === 'payments' && uuid"
      )
        .columns
          .column
            .result-address
              tab-payments(
                :isMultiChain="chains.length > 1"
                :uuid='uuid'
                ref="paymentstab"
                @startLoading="isLoadingPaymentsData = true"
                @stopLoading="isLoadingPaymentsData = false"
              )

      .tab-content(
        :class="{'is-loading': isLoadingReferralData}"
        v-if="selectedTab.code === 'referrals' && uuid"
      )
        .columns
          .column
            .result-address
              tab-referral(
                :uuid='uuid'
                ref="referralstab"
                @startLoading="isLoadingReferralData = true"
                @stopLoading="isLoadingReferralData = false"
              )


      .tab-content(
        :class="{'is-loading': isLoadingStatsData}"
        v-if="selectedTab.code === 'stats' && uuid"
      )
        .columns
          .column
            .result-address
              tab-stats(
                :paymentThreshold='paymentThreshold'
                :miningFee='miningFee'
                :uuid='uuid'
                ref="statstab"
                @startLoading="isLoadingStatsData = true"
                @stopLoading="isLoadingStatsData = false"
              )
    .column.col-result.is-full(v-if="missingMemoView")
      button.button.button-back-search(@click="closeCurrentAddress()")
        img.chevron(:src="'/img/icons/left-chevron-' + mode +  '.svg'", alt="Scroll right")
        span Back
      .result-address
        br
        .fs-18.mt-10
          span ⚠️
        .fs-14.mt-10
          span Please note that if you are currently trying to mine to this address:
        .fs-20.mt-10
          b {{ address }}
        .fs-14.mt-10
          b You'll have all of your connections rejected as it is an exchange or custodial wallet address that requires payment tags for payouts. Any mining rewards associated with this address (without a payment tag) are unrecoverable and non-transferable.
        .fs-14.mt-10
          b To correctly start mining, 
          span  include your Payment ID, Memo, or Tag immediately after the address in the user parameter of your miner, separated by a colon (:), like this:
        .fs-17.mt-10.wb-ba
          b.opacity-05 {{ coin }}
          b.fredoka-style :
          b.opacity-05 {{ address }}
          b.fredoka-style :
          b YourPaymentID
          b.fredoka-style .
          b.opacity-05 YourWorkerName
        .fs-12.mt-10
          span Learn more about 
          a(href="/support/article/why-is-it-necessary-to-write-the-memo-or-payment-tag", target="_blank") 
            span exchange addresses 
            i.fa.fa-external-link
        .fs-14.mt-10
          span Happy mining!
</template>

<script>
import { apiGet, apiPost, apiPostPay } from '../util/general'
import News from '../components/c_news'
import StatNotification from '../components/c_stats_notification'
import TabStats from '../components/c_tab_stats'
import TabPayments from '../components/c_tab_payments'
import TabWorkers from '../components/c_tab_workers'
import TabLive from '../components/c_tab_live'
import TabReferral from '../components/c_tab_referral'
import TabOption from '../components/c_tab_option_select'
import CoinFilter from '../components/c_coin_filter'
import ICountUp from 'vue-countup-v2'
import BigNumber from 'bignumber.js'
import ContentCreatorLink from '../components/c_content_creator_link'
import GenerateQR from '../components/c_generate_qr'
import ConnectionId from '../components/c_connection_id'
import CoinSwitcher from '../components/c_coin_switcher'
import PlatformStats from '../components/c_platform_stats'
import Slider from '../components/c_slider'

export default {
  name: 'view_stats',
  // props: ['addressqs', 'tab'],
  props: ['addressqs'],
  components: {
    News,
    StatNotification,
    TabLive,
    TabWorkers,
    TabStats,
    TabPayments,
    TabReferral,
    'count-up': ICountUp,
    TabOption,
    CoinFilter,
    ContentCreatorLink,
    GenerateQR,
    ConnectionId,
    CoinSwitcher,
    PlatformStats,
    Slider
  },
  data() {
    return {
      reloadLastViewed: true,
      showAlwaysReload: true,
      showAlwaysInactivity: false,
      forceReRender: true,
      calculatedBalanceFontSize: 60,
      showSearch: true,
      missingMemoView: false,
      disableInput: true,
      address: '',
      addressQuickSearch: '',
      uuid: '',
      addressFound: false,
      isFindingAddress: false,
      chains: [],
      network: '',
      selectedChain: {},
      precision: 8,
      isMissingMemo: false,
      hasPaymentError: false,
      isRestricted: false,
      isEnabled: false,
      isEnabledOnlyAutomatic: false,
      isFresh: false,
      isNotActivated: false,
      hasNoWorkers: false,
      addressFromDB: '',
      connectionId: '',
      miningFee: '',
      balance: null,
      balancePayable: 0,
      autoPay: false,
      paymentThreshold: 0,
      memo: '',
      maintenanceMessage: '',
      isOpenPayingOutNow: false,
      isPayingOutNow: false,
      isOpenSwitchingNetwork: false,
      isSwitchingNetwork: false,
      isConfirmingSwitchNetwork: false,
      selectedChainToSwitch: {},
      inactiveAccount: true,
      listOfTabs: [
        { code: 'live', name: 'Live' },
        { code: 'workers', name: 'Workers' },
        { code: 'payments', name: 'Payments' },
        { code: 'referrals', name: 'Referrals' },
        { code: 'stats', name: 'Stats' }
      ],
      selectedTab: { code: 'live', name: 'Live' },
      isLoadingReferralData: false,
      isLoadingWorkersData: true,
      isLoadingStatsData: false,
      isLoadingPaymentsData: false,
      isLoadingLiveData: false,
      isLoadingSameAddress: false,
      isLoadingHub: false,
      tabExists: false,
      quickSearching: false,
      loadingCoin: '',
      previousBalance: 0,
      countUpAmountOptions: {
        duration: 1,
        separator: '',
        decimalPlaces: 0,
        startVal: 0
      },
      screenWidth: 0,
      hasCustomCode: false,
      customCodeTierName: '',
      showQR: false,
      showConnectionId: false,
      // listOfLastAddresses: [],
      summary: {
        algorithmCount: 0,
        workerCount: 0,
        hashrates: [],
        lastUpdate: 0,
        updated: false
      },
      watchedAddressesBalance: {},
      noPointerEvents: false,
      tiles: [
        {
          title: 'Introducing Accounts',
          subtitle: 'Built with flexibility in mind, the next iteration of our platform will allow miners to better distribute their hash rate, along with more useful features',
          link: 'https://unmineable.com/account'
        },
        {
          title: 'A new website experience',
          subtitle: 'We continue to work on improving the website for the upcoming features. Feel free to contact us if you have any suggestions or feedback'
        }
        // {
        //   title: 'How mining actually works?',
        //   subtitle: 'Be sure to check our comprehensive explanation on how our platform works and the risks involved',
        //   link: 'https://twitter.com/un_mineable/status/1773098420930011230'
        // }
      ],
      isMobile: window.innerWidth <= 768
    }
  },
  watch: {
    balance: function () {
      let vm = this
      let decimalPlaces = 0;
      vm.forceReRender = false;
      if (!vm.balance || Math.floor(vm.balance) === vm.balance) decimalPlaces = 0
      else decimalPlaces = (vm.balance.toString().split('.')[1] || '').length || 0;
      vm.countUpAmountOptions.decimalPlaces = decimalPlaces
      vm.countUpAmountOptions.startVal = vm.previousBalance
      this.$nextTick(() => {
        vm.forceReRender = true
        vm.recalculateFontSize()
      })
      vm.previousBalance = vm.balance;
    }
  },
  computed: {
    preCoin () {
      let vm = this
      return vm.$store.getters.preCoin || vm.$store.getters.coinSymbol
    },
    lastAddressesCoin () {
      let vm = this
      return vm.listOfLastAddresses.slice(1, 3)
    },
    tileBlocks () {
      let vm = this
      if (vm.isMobile) {
        let aux = []
        for (let item of vm.tiles) {
          aux.push([ item ])
        }
        return aux
      } else return [ vm.tiles ]
    },
    tab () {
      let vm = this
      return vm.$route.query.tab
    },
    listOfCoins () {
      let vm = this
      let coins = vm.$store.getters.coins;
      let lastAddressesPerCoin = vm.$store.getters.lastAddresses;
      let appliedFilters = vm.$store.getters.lastAddressCoinFilters;
      let uniqueCoins = [];
      for (let key in lastAddressesPerCoin) {
        let foundCoin = coins.find(coin => coin.symbol === key);
        if (foundCoin) {
          uniqueCoins.push({
            coin: key,
            logo: foundCoin.logo,
            active: appliedFilters.indexOf(key) > -1
          })
        }
      }
      uniqueCoins = uniqueCoins.sort((a, b) => { return +b.active - +a.active; });
      return uniqueCoins
    },
    listOfLastAddresses () {
      let vm = this
      let listOfLastAddresses = [];

      let searchHistory = vm.$store.getters.addressHistory;
      let coins = vm.$store.getters.coins;
      for (let i = 0; i < searchHistory.length; i++) {
        for (let j = 0; j < searchHistory[i].addresses.length; j++) {
          let foundCoin = coins.find(coin => coin.symbol === searchHistory[i].coin);
          if (foundCoin) {
            listOfLastAddresses.push({
              coin: searchHistory[i].coin,
              coinLogo: foundCoin.logo,
              address: searchHistory[i].addresses[j].address,
              uuid: searchHistory[i].addresses[j].uuid,
              balance: searchHistory[i].addresses[j].balance || '0',
              animate: searchHistory[i].addresses[j].shouldAnimate,
              // viewed: dayjs().to(dayjs(searchHistory[i].addresses[j].last_viewed)),
              viewed: searchHistory[i].addresses[j].last_viewed,
              updated: searchHistory[i].addresses[j].last_updated,
              formattedAddress: vm.getFormattedAddress(searchHistory[i].addresses[j].address),
              formattedAddressMedium: vm.getFormattedAddressMedium(searchHistory[i].addresses[j].address),
              formattedAddressShort: vm.getFormattedAddressShort(searchHistory[i].addresses[j].address)
            })
          }
        }
      }

      return listOfLastAddresses
    },
    trimmedAddress() {
      let vm = this
      let numberOfChars = 16;
      if (vm.screenWidth < 500) numberOfChars = 9
      if (vm.addressFromDB && vm.addressFromDB.length > 23) {
        return vm.addressFromDB.substring(0, numberOfChars) + '...' + vm.addressFromDB.substring(vm.addressFromDB.length - numberOfChars, vm.addressFromDB.length)
      } else return vm.addressFromDB
    },
    trimmedMemo() {
      let vm = this
      let numberOfChars = 16;
      if (vm.screenWidth < 500) numberOfChars = 9
      if (vm.memo && vm.memo.length > 23) {
        return vm.memo.substring(0, numberOfChars) + '...' + vm.memo.substring(vm.memo.length - numberOfChars, vm.memo.length)
      } else return vm.memo
    },
    coins() {
      return this.$store.getters.coins
    },
    coin() {
      return this.$store.getters.coinSymbol
    },
    coinName() {
      return this.$store.getters.coinData.name
    },
    coinLogo() {
      return this.$store.getters.coinData.logo
    },
    isMemoCoin() {
      return !!this.$store.getters.coinData.regex_memo
    },
    noPOWMessage() {
      let vm = this
      return ['BTC', 'BTG', 'DASH', 'DOGE', 'ETC', 'ETH', 'LTC', 'RVN', 'XMR', 'BCH', 'SC', 'SKY', 'VIA'].indexOf(vm.coin) > -1
    },
    hasReachPaymentThreshold() {
      let vm = this
      return +vm.balance >= vm.paymentThreshold
    },
    hasPayoutNowDisabled() {
      let vm = this
      return vm.autoPay || !vm.isEnabled || !vm.hasReachPaymentThreshold
    },
    messageCanNotPayoutNow() {
      let vm = this
      if (!vm.isEnabled) {
        return (vm.selectedChain.token_standard || vm.selectedChain.network) + ' payouts are under maintenance'
      } else if (+vm.balance < vm.paymentThreshold) {
        return 'The minimum payment is ' + vm.paymentThreshold + ' ' + vm.coin
      } else if (vm.autoPay) {
        return 'You must first deactivate the auto payment setting.'
      } else return ''
    },
    tiers() {
      return this.$store.getters.tiers
    },
    mode() {
      return this.$store.getters.mode
    },
    addressHistory() {
      return this.$store.getters.addressHistory
    },
    newCoins() {
      return this.$store.getters.newCoins
    },
    recentCoins() {
      return this.$store.getters.recentCoins
    }
  },
  created() {
    let vm = this
    vm.updateMetaTags()
    vm.$store.dispatch('setPageSelected', 'address')
    vm.$store.dispatch('validateVersion')
  },
  mounted() {
    let vm = this
    window.addEventListener('resize', vm.getDimensions);
    window.addEventListener('resize', vm.recalculateFontSize);
    setInterval(vm.intervalLastViewed, 1000);
    // Lazy load balances
    vm.$store.dispatch('loadBalances')
    vm.clearFilterCoin()
    vm.emitForBalance('join')
    if (vm.addressqs) {
      vm.address = vm.addressqs
      // if (vm.address) vm.isFindingAddress = true
      // Always get the latest addresses
      if (vm.coin) {
        if (vm.$route.query.coin && vm.$route.query.coin !== vm.coin) {
          // re-set the coin
          vm.$store.dispatch('setCoin', { coin: vm.$route.query.coin }).then(() => {
            vm.updateMetaTags()
            vm.verifyUrlTab()
            vm.findAddress()
            vm.$store.dispatch('addToCoinList', vm.coin)
          }).catch(() => {
            vm.findAddress()
          })
        } else {
          vm.updateMetaTags()
          vm.verifyUrlTab()
          vm.findAddress()
          vm.$store.dispatch('addToCoinList', vm.coin)
        }
      }
    } else {
      if (vm.coin) {
        vm.updateMetaTags()
        vm.verifyUrlTab()
        // Always get the latest address
        vm.$store.dispatch('getLastAddressPerCoin', vm.coin).then((lastAddress) => {
          if (lastAddress) {
            vm.address = lastAddress
            vm.$router.push('/address/' + vm.address + '?coin=' + vm.coin)
            vm.findAddress()
          } else {
            vm.disableInput = false
          }
        })
      }
    }

    let intervalHintRemove = setInterval(async function () {
      vm.showAlwaysReload = false
      clearInterval(intervalHintRemove)
    }, 3000)
  },
  sockets: {
    connect() {
    },
    event(data) {
      let vm = this
      if (vm.uuid === data.u && vm.selectedTab.code === 'live') {
        if (data.e === 'summary' && vm.selectedTab.code === 'live') {
          vm.summary.algorithmCount = data.d.a
          vm.summary.workerCount = data.d.w
          let hashrates = data.d.h
          vm.summary.hashrates = Object.entries(hashrates).map(([name, value]) => ({ name, value }))
          vm.summary.lastUpdate = data.t
          vm.$refs.livetab.updateSummary()
        } else if (data.e === 'reward') {
          vm.$refs.livetab.addEvent(data)
        } else if (data.e === 'worker') {
          vm.$refs.livetab.addEvent(data)
        } else if (data.e === 'payout') {
          vm.$refs.livetab.addEvent(data)
        }
      }
    },
    balance(data) {
      let vm = this
      if (vm.uuid === data.uuid) {
        vm.balance = data.b + ''
        vm.balancePayable = data.pb + ''
      }
      vm.$store.dispatch('setAddressHistoryBalance', {
        uuid: data.uuid,
        balance: BigNumber(data.b).toFixed()
      })
    }
  },
  unmounted() {
    let vm = this
    window.removeEventListener('resize', this.getDimensions);
    window.removeEventListener('resize', this.recalculateFontSize);
    clearInterval(vm.intervalLastViewed);
    this.$socket.client.emit('leave_account', this.uuid);
  },
  beforeRouteLeave(to, from, next) {
    this.emitForBalance('leave')
    this.$socket.client.emit('leave_account', this.uuid);
    next()
  },
  methods: {
    setTitle(title) {
      document.title = title
      const metaTitle = document.querySelector('head meta[property="og:title"]');
      metaTitle.setAttribute('content', title);
    },
    clearFilterCoin () {
      let vm = this
      vm.$store.dispatch('clearLastAddressesCoinFilter')
    },
    toggleFilterCoin (coin) {
      let vm = this
      vm.$store.dispatch('toggleLastAddressesCoinFilter', coin)
    },
    emitForBalance (operation = 'join') {
      let vm = this
      for (let item of vm.listOfLastAddresses) {
        if (item.uuid) {
          vm.$socket.client.emit(`${operation}_account`, item.uuid);
        }
      }
    },
    closeCurrentAddress () {
      let vm = this
      vm.missingMemoView = false;
      vm.showSearch = true;
      vm.address = ''
      vm.$router.push('/address')
      this.$socket.client.emit('leave_account', this.uuid);
      vm.$store.dispatch('loadBalances')
      vm.emitForBalance('join')
    },
    intervalLastViewed () {
      let vm = this
      vm.reloadLastViewed = false;
      this.$nextTick(() => {
        vm.reloadLastViewed = true;
      })
    },
    recalculateFontSize () {
      let vm = this
      let nChars = (+vm.balance + '').length
      let fontSizeRatio = 0.6
      let extraValues = 35 + // img size
        10 + // margin left img
        48 + // global padding
        20 // closest container padding
      let width = window.innerWidth;

      vm.calculatedBalanceFontSize = Math.floor((width - extraValues) / (nChars * fontSizeRatio))
      if (vm.calculatedBalanceFontSize > 60) vm.calculatedBalanceFontSize = 60
    },
    copyToClipboard(text, type) {
      let vm = this
      const clipboardData = event.clipboardData || window.clipboardData || navigator.clipboard;
      clipboardData.writeText(text);
      vm.$store.dispatch('notifySuccess', `The ${type} have been copied!`)
    },
    updateMetaTags() {
      let vm = this
      let title = ''

      if (!vm.coinName) {
        vm.$store.dispatch('setCoin', { coin: vm.coin }).then(() => {
          title = 'unMineable - ' + vm.coinName + ' (' + vm.coin + ') mining pool - Earn ' + vm.coin + ' with your Graphics Cards, CPU & ASICs'
          vm.setTitle(title)
        }).finally(() => {
        })
      } else {
        title = 'unMineable - ' + vm.coinName + ' (' + vm.coin + ') mining pool - Earn ' + vm.coin + ' with your Graphics Cards, CPU & ASICs'
        vm.setTitle(title)
      }
    },
    verifyUrlTab() {
      let vm = this
      if (vm.tab) {
        vm.tabExists = false
        for (var i = vm.listOfTabs.length - 1; i >= 0; i--) {
          if (vm.listOfTabs[i].code === vm.tab) vm.tabExists = true
        }
        if (vm.tabExists) {
          vm.changeTab(vm.tab)
        }
      }
    },
    reloadStats () {
      let vm = this
      vm.findAddressPre()
    },
    findAddressPre() {
      let vm = this
      if (!vm.disableInput) {
        if (vm.address && !vm.isFindingAddress) {
          vm.noPointerEvents = true
        }
        if (vm.uuid) this.$socket.client.emit('leave_account', this.uuid);
        vm.selectedTab = { code: 'live', name: 'Live' }
        vm.findAddress()
      }
    },
    findAddressPreQuick() {
      let vm = this
      if (vm.addressQuickSearch) {
        vm.address = vm.addressQuickSearch
        vm.findAddress(true)
        // vm.address = vm.addressQuickSearch
        // vm.findAddress(true)
        // vm.$store.dispatch('setCoin', { coin: vm.preCoin }).then(() => {
        //   vm.$store.dispatch('addToCoinList', vm.preCoin)
        //   // if (!vm.disableInput) {
        //   //   if (vm.address && !vm.isFindingAddress) {
        //   //     vm.noPointerEvents = true
        //   //   }
        //   // }
        //   if (vm.uuid) this.$socket.client.emit('leave_account', this.uuid);
        //   vm.address = vm.addressQuickSearch
        //   vm.$router.push('/address/' + vm.address + '?coin=' + vm.coin)
        //   vm.selectedTab = { code: 'live', name: 'Live' }
        //   vm.findAddress()
        // }).catch((err) => {
        //   console.error(err)
        // })
      }
    },
    selectCoinFromSwitcher() {
      let vm = this
      vm.updateMetaTags()
      vm.verifyUrlTab()
      // Always get the latest address
      vm.$store.dispatch('getLastAddressPerCoin', vm.coin).then((lastAddress) => {
        if (lastAddress) {
          vm.address = lastAddress
          vm.$router.push('/address/' + vm.address + '?coin=' + vm.coin)
          vm.findAddress()
        } else {
          vm.disableInput = false
        }
      })
    },
    selectCoinFromCompactSwitcher(o) {
      document.getElementById('quick').focus()
    },
    findAddress(isQuick) {
      let vm = this
      vm.disableInput = false
      if (vm.address && !vm.isFindingAddress) {
        vm.isFindingAddress = true
        vm.address = vm.address.trim()

        if (vm.addressqs === vm.address) vm.isLoadingSameAddress = true
        else vm.isLoadingSameAddress = false

        vm.addressFound = false
        let url = '/v5/address/' + vm.address + '?coin=' + (isQuick ? vm.preCoin : vm.coin)
        var obj = {}
        apiGet(vm, url, obj, function (data) {
          if (data.success) {
            if (isQuick) {
              vm.$store.dispatch('setCoin', { coin: vm.preCoin }).then(() => {
                vm.$store.dispatch('addToCoinList', vm.preCoin)
                if (vm.uuid) vm.$socket.client.emit('leave_account', vm.uuid);
                vm.$router.push('/address/' + vm.address + '?coin=' + vm.preCoin)
                vm.selectedTab = { code: 'live', name: 'Live' }
                vm.updateMetaTags()
                vm.verifyUrlTab()
                vm.loadData(data.data)
              }).catch((err) => {
                console.error(err)
              })
            } else {
              vm.loadData(data.data)
            }
          } else {
            vm.addressFound = false
          }
        }, function (err) {
          if (err.request.status === 404) {
            let notificationCoin = vm.coin
            if (isQuick) notificationCoin = vm.preCoin
            vm.$store.dispatch('notifyWarning', `Your address seems to be invalid or is not ${('aeiou'.split('').indexOf((notificationCoin[0]).toLowerCase()) > -1) ? 'an' : 'a'} ${notificationCoin} address!`)
          } else {
            console.error('Error:', err.message)
            vm.$store.dispatch('notifyError')
          }
        }, function () {
          vm.addressQuickSearch = ''
          vm.isFindingAddress = false
          vm.noPointerEvents = false
        })
      }
    },
    async loadData(data) {
      let vm = this
      vm.missingMemoView = false;
      vm.isMissingMemo = data.err_flags.missing_memo

      if (data.err_flags && data.err_flags.missing_memo) {
        vm.showSearch = false
        vm.missingMemoView = true
        return
      }

      vm.uuid = data.uuid
      vm.chains = data.chains
      vm.selectedChain = data.chains.find(item => item.network === data.network);

      vm.network = data.network
      vm.hasPaymentError = data.err_flags.payment_error
      vm.isRestricted = data.err_flags.restricted
      vm.isEnabled = data.enabled
      vm.maintenanceMessage = data.maintenance_message
      vm.isEnabledOnlyAutomatic = data.enabled_auto_only
      vm.isDelisted = data.delisted_chain
      vm.isFresh = data.fresh
      vm.isNotActivated = data.err_flags.not_activated

      vm.addressFromDB = data.address
      vm.connectionId = data.mining_key

      vm.miningFee = data.mining_fee

      vm.inactiveAccount = data.inactive

      if (data.inactive) {
        vm.showAlwaysInactivity = true
        let intervalHintInactivity = setInterval(async function () {
          vm.showAlwaysInactivity = false
          clearInterval(intervalHintInactivity)
        }, 3000)
      }

      vm.balance = data.balance
      vm.balancePayable = data.balance_payable

      vm.recalculateFontSize()

      vm.precision = +data.precision || 8

      // vm.countUpAmountOptions.decimalPlaces = vm.precision
      // vm.countUpAmountOptions.decimalPlaces = vm.balance.split('.')[1].length

      vm.autoPay = data.auto
      vm.paymentThreshold = data.payment_threshold
      vm.memo = data.memo

      vm.hasCustomCode = data.has_custom_referral_code

      vm.$store.dispatch('setPreCoin', { coin: vm.coin })

      vm.$store.dispatch('addAddressToHistory', {
        coin: vm.coin,
        address: vm.address,
        uuid: vm.uuid
      })

      // vm.listOfLastAddresses = [];
      // setTimeout(function () {
      // }, 100)
      this.$nextTick(() => {
        vm.$socket.client.emit('join_account', vm.uuid);
        if (vm.selectedTab && vm.selectedTab.code === 'live') vm.$refs.livetab.fetch(true)
        vm.$refs.workerstab.fetch()
        vm.showSearch = false
        vm.addressFound = true
      })
    },
    openPayoutNow() {
      let vm = this
      vm.isOpenPayingOutNow = true
    },
    confirmingSwitchNetwork(item) {
      let vm = this
      vm.selectedChainToSwitch = item
      vm.isConfirmingSwitchNetwork = true
    },
    cancelConfirmingSwitchNetwork() {
      let vm = this
      vm.selectedChainToSwitch = {}
      vm.isConfirmingSwitchNetwork = false
    },
    doChangeAutoPay() {
      let vm = this
      vm.isOpenPayingOutNow = false

      var url = '/v1/address/' + vm.uuid + '/setting/auto_pay'
      var obj = {
        setting: vm.autoPay
      }
      apiPost(vm, url, obj, function (data) {
        vm.$store.dispatch('notifySuccess', 'Your settings have been updated!')
      }, function (err) {
        console.error('Error: ', err.message)
        vm.$store.dispatch('notifyError')
      }, function () {
      })
    },
    doSwitchNetwork(item) {
      let vm = this

      if (!vm.isSwitchingNetwork) {
        vm.isSwitchingNetwork = true

        var url = '/v3/address/' + vm.uuid + '/switch?network=' + item.network
        var obj = {
        }
        apiPostPay(vm, url, obj, function (data) {
          vm.$store.dispatch('notifySuccess', 'Your network have been updated!')
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        }, function (err) {
          vm.$store.dispatch('notifyError', err.message)
        }, function () {
          vm.isSwitchingNetwork = false
        })
      }
    },
    doPayout() {
      let vm = this

      if (!vm.isPayingOutNow) {
        vm.isPayingOutNow = true

        var url = '/v3/address/' + vm.uuid + '/pay'
        var obj = {
        }
        apiPostPay(vm, url, obj, function (data) {
          if (data.success) {
            vm.$store.dispatch('notifySuccess', 'Your payment have been initiated!')
            vm.findAddressPre()
            vm.isOpenPayingOutNow = false
          } else {
            vm.$store.dispatch('notifyError', data.message)
          }
        }, function (err) {
          console.error('Error:', err.message)
          vm.$store.dispatch('notifyError')
        }, function () {
          vm.isPayingOutNow = false
        })
      }
    },
    changeTab(selectedTab) {
      let vm = this

      if (typeof selectedTab === 'string') {
        selectedTab = vm.listOfTabs.find(element => element.code === selectedTab)
      }

      if (selectedTab && selectedTab.code) {
        if (vm.selectedTab.code !== selectedTab.code) {
          vm.selectedTab = selectedTab
          this.$nextTick(() => {
            vm.changeTabSubAction(false)
          })
        } else {
          vm.changeTabSubAction(true)
        }
      }
    },
    changeTabSubAction(reload) {
      let vm = this
      if (vm.selectedTab.code === 'live') {
        if (vm.$refs.livetab) vm.$refs.livetab.fetch()
        let urlPage = '/address/' + vm.address + '?coin=' + vm.coin
        vm.$router.push(urlPage)
      } else if (vm.selectedTab.code === 'workers') {
        // if (reload) vm.$refs.workerstab.fetch()
        vm.$refs.workerstab.fetch()
        let urlPage = '/address/' + vm.address + '?coin=' + vm.coin + '&tab=workers'
        vm.$router.push(urlPage)
      } else if (vm.selectedTab.code === 'referrals') {
        if (reload && vm.$refs.referralstab) vm.$refs.referralstab.fetch()
        let urlPage = '/address/' + vm.address + '?coin=' + vm.coin + '&tab=referrals'
        vm.$router.push(urlPage)
      } else if (vm.selectedTab.code === 'stats') {
        if (reload && vm.$refs.statstab) vm.$refs.statstab.fetch()
        let urlPage = '/address/' + vm.address + '?coin=' + vm.coin + '&tab=stats'
        vm.$router.push(urlPage)
      } else if (vm.selectedTab.code === 'payments') {
        if (reload && vm.$refs.paymentstab) vm.$refs.paymentstab.fetch()
        let urlPage = '/address/' + vm.address + '?coin=' + vm.coin + '&tab=payments'
        vm.$router.push(urlPage)
      }
    },
    changeSubTab(selectedSubTab) {
      let vm = this
      vm.selectedSubTab = selectedSubTab
    },
    openSwitchNetwork() {
      let vm = this
      vm.isOpenSwitchingNetwork = true
    },
    getDimensions() {
      let vm = this
      let width = window.screen.width;
      if (width) {
        vm.screenWidth = width
      }
    },
    generateQR() {
      let vm = this
      vm.showQR = true
    },
    openConnectionId() {
      let vm = this
      vm.showConnectionId = true
    },
    selectAddressFromPrevious(o) {
      let vm = this
      vm.closeCurrentAddress()
      vm.selectAddressFromFinder(o)
    },
    selectAddressFromFinder(o) {
      let vm = this
      if (!vm.noPointerEvents) {
        vm.noPointerEvents = true
        // vm.$store.dispatch('loadBalances')
        // vm.emitForBalance()
        vm.$store.dispatch('addAddressToHistory', {
          coin: o.coin,
          address: o.address,
          uuid: o.uuid
        })
        vm.address = o.address
        vm.disableInput = true // TODO check
        window.scrollTo(0, 0)
        vm.selectedTab = { code: 'live', name: 'Live' }
        if (vm.coin === o.coin) {
          vm.$router.push('/address/' + vm.address + '?coin=' + vm.coin)
          vm.findAddress()
        } else {
          vm.$router.push('/address/' + o.address + '?coin=' + o.coin);
          vm.$store.dispatch('setCoin', { coin: o.coin }).then(() => {
            vm.findAddress()
          });
        }
      }
    },
    getFormattedAddress(o) {
      if (o.length > 22) {
        let start = o.substring(0, 9);
        let end = o.substring(o.length - 10, o.length);
        return `${start}...${end}`;
      } else return o
    },
    getFormattedAddressMedium(o) {
      if (o) {
        let start = o.substring(0, 7);
        let end = o.substring(o.length - 7, o.length);
        return `${start}...${end}`;
      } else return o
    },
    getFormattedAddressShort(o) {
      if (o) {
        let start = o.substring(0, 4);
        let end = o.substring(o.length - 4, o.length);
        return `${start}...${end}`;
      } else return o
    },
    removeAddressFromLastAddress(o, listIndex) {
      let vm = this
      vm.$store.dispatch('removeAddressFromHistory', {
        coin: o.coin,
        address: o.address
      })
    },
    selectNewCoin(o) {
      let vm = this
      if (!vm.isFindingAddress) {
        vm.loadingCoin = o.symbol
        vm.$store.dispatch('setCoin', { coin: o.symbol }).then(() => {
          vm.$store.dispatch('addToCoinList', o.symbol)
          vm.updateMetaTags()
          vm.verifyUrlTab()
          // Always get the latest address
          vm.$store.dispatch('getLastAddressPerCoin', vm.coin).then((lastAddress) => {
            if (lastAddress) {
              vm.address = lastAddress
              vm.$router.push('/address/' + vm.address + '?coin=' + vm.coin)
              vm.findAddress()
            } else {
              vm.disableInput = false
            }
          })
          vm.loadingCoin = ''
        }).catch((err) => {
          console.error(err)
        })
      }
    },
    openCoinSwitcher() {
      let vm = this
      document.querySelector('html').style.overflow = 'hidden'
      vm.$store.dispatch('openCoinSwitcher')
    },
    handleFocus () {
      let vm = this
      vm.quickSearching = true
      document.getElementById('quick').focus()
    },
    handleFocusOut() {
      let vm = this
      vm.quickSearching = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.result-address
  display: block;
  // max-width: 720px;
  max-width: 1080px;
  margin: auto;
.padding-container
  padding:10px 10px 20px 10px

.button-back-search
  background transparent
  font-size 11px
  margin-bottom: 5px;
  margin-right 5px
  &.button-coin-inline
    padding: 0px;
    margin-right: -1px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    &:hover
      z-index 9
  &.quick-search
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    display inline-flex
    .search-icon
      color #c7c7c7
      &.searching
        color #000
    &.loading-quick
      background whitesmoke
    input
      transition: width .3s ease;
      box-shadow: none;
      border: none;
      outline: none;
      padding: 0px;
      height: 20px;
      width: 75px;
      font-size: 11px;
      &.searching
        width 175px
  img
    width 10px
    margin-right 5px
.big-info
  display: inline-block
  width 33.333333%
  vertical-align: top
  &.dual
    width 50%
  &.main
    width 100%
    .big-info-number
      b
        font-size 55px
        font-weight: 300;
      .count-up-balance
        font-size: 60px;
        font-weight: 700;
        vertical-align: bottom;
        // font-family: Poppins;
        font-family: 'Roboto Mono';
        // color: #585858;
        color #686868
        margin-left 0px
        margin-bottom 0px
        vertical-align: middle;
      img
        margin-left 10px
        width 35px
        vertical-align: middle;
        border-radius 5px
    span
      font-size 12px
    .current-address-view span
      font-size 15px
    .pay-block, .confirm-pay-block
      margin-top: 0px;
      span, b
        font-size: 12px;
      div.end
        margin-bottom: 8px;
      button
        margin-right: 5px;
    label.checkbox
      margin-top: 6px;
      span
        font-size: 12px;
  .big-info-number
    b
      font-size: 35px
      font-weight: 300;
      vertical-align: bottom
    span
      // font-family: 'Major Mono Display'
      font-weight 700
      font-size: 13px
      display: inline-block
      vertical-align: bottom
      margin-bottom: 20px;
      margin-left: 5px;
  span
    font-family: Poppins
    color: #585858;

.tile
  .title
    font-size 1.25rem
  .subtitle
    font-size: 0.9rem;
    i
      vertical-align middle
.separator-circle
  display: inline-block;
  margin: 0px 7.5px 0px 5px;
  height: 5px;
  width: 5px;
  background: #cccccc;
  vertical-align: middle;
  border-radius: 50%;

.top-fee-disclaimer
  display: inline-block;
  span
    font-size: 12px;
  i
    cursor pointer
  a
    color #000

.address-search-field
  max-width 344px
.top-option
  display: inline-block; 
  padding: 2.5px 10px; 
  background: #f2f2f2; 
  border-radius: 5px; 
  margin-left: 5px; 
  color: #626262; 
  font-size: 11px; 
  font-weight: 400;
  .top-option-text
    font-size: 9px !important;
    color: #797979;

.autopay-switch-block
  margin-top 5px;

.wmemo
  font-weight: 400

.network-item .button-selector .button[disabled]
  background: #c5c5c5;

.network-item
  display: inline-block;
  padding: 15px;
  border: solid 1px #ccc;
  border-radius: 10px;
  vertical-align: top;
  margin-right 10px
  margin-bottom 10px
  width: 250px;
  .network-name, .network-feature
    font-size: 12px;
  .network-token
    font-weight: 400;
    font-size: 25px;
  .button-selector
    margin-top: 10px;
    .button
      margin-left 5px;
      i
        font-size: 10px;
        margin-top: 3px;
        margin-left: 3px;
  .confirm-block-network
    padding: 10px 15px;
    background: #fffdbf;
    margin-top: 10px;
    border-radius: 10px;
    font-weight: 400;
    
.padding-workers
  padding: 0px 0px 25px 10px

.tab-content
  max-width 1080px

.tab-content.is-loading
  position relative
  &:after
    content: "Loading...";
    text-align: center;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: 20px 0px;
    color: #000;
    height: 100%;
    background: rgba(255,255,255, .8);
    transition: all .1s ease;

.balance.is-loading
  &:after
    content: "Loading...";
    text-align: center;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: 20px 0px;
    color: #000;
    height: 100%;
    background: rgba(255,255,255,0.8);
    transition: all 0.1s ease;
    font-size 16px
  
.min-height-balance
  min-height 77px
  line-height 77px
  
.autopay-message:hover:after
  font-weight 400

.icon-angle-address
  cursor pointer
  pointer-events auto !important
  i
    font-size 1.5rem

.no-pointer-events
  pointer-events none

.button-address
  border-radius: 4px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;

.button-address-container
  margin-right 0px !important

.min-width-300
  min-width: 300px

.animated-circle
  content: ''; 
  height: 7.5px; 
  width: 7.5px; 
  display: inline-block; 
  border-radius: 50%; 
  margin-left: 2.5px; 
  vertical-align: middle;
  margin-right: 5px;
  animation: 5s rotate linear infinite;
  background: linear-gradient(var(--angle), #d8ff58, #80ecb7);
  cursor pointer
  &.inactive
    background: linear-gradient(var(--angle), #ffc258, #ebc880)

// .col-result
//   max-width: 1080px;

.current-address-view
  padding: 0px 0px 10px 0px;
  span.address_
    font-family: Azeret Mono,monospace;
    cursor pointer
  .reload-control, span.address_copy_
    padding 0px 2.5px 0px 10px
    cursor pointer
    color #585858
    i
      font-size 17px
      vertical-align middle
  span.address_copy_
    padding-right 0px
    display none

.prev-label
  padding: 5px 0px 15px 0px;
  font-size: 14px;
.filter-label
  padding 5px
  span
    font-size 13px

.newest-list
  display inline-block
  margin-left: 10px;
  .new-coin-separator
    vertical-align: middle;
    width: 2px;
    background: #d5d5d5;
    display: inline-block;
    height: 25px;
    margin-right: 7.5px;
    border-radius: 14px;
  .new-coin
    cursor pointer
    display: inline-block;
    text-align: center;
    margin-right: 7.5px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-radius: 10px;
    position: relative;
    .new-tag
      position: absolute;
      background: #b6ffb6;
      bottom: -6px;
      right: -3px;
      border-radius: 2px;
      font-size: 6px;
      font-weight: 700;
      padding: 2px 5px;
      &:after
        content "New"
    &.is-loading
      .new-coin-logo img
        opacity .3
    &:not(.view-all)
      background: #f5f5f5;
    &.view-all
      font-weight: 700;
      font-size: 12px;
      border: none;
      padding: 10px 5px;
      i
        margin-left 7.5px
    .new-coin-loading
      position: absolute;
      top: calc(50% - 10px);
      left: calc(50% - 8px);
    .new-coin-logo
      text-align: center;
      img
        display: inline-block;
        vertical-align: middle;
        width: 20px;
    .new-coin-name
      margin-top 5px
      text-align: center;
      font-weight: 700;
      font-size: 12px;
      color: #5d5d5d;

@media (max-width: 550px)
  .new-coin-separator
    display none !important
  .recent-item-el
    padding-bottom: 10px;
    display: block;
  .newest-list
    margin-left: 0px
  .newest-list .new-coin .new-tag
    bottom: -3px;
    padding: 0px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    &:after
      content ""
  .button-back-search.quick-search, .button-back-search.button-coin-inline
      display none

.prev-address
  // margin: 8px 16px 8px 0px;
  // display: inline-block;
  .content-last
    font-size 11px
  .content-balance
    .count-up-balance
      // font-size: 60px;
      font-weight: 700;
      vertical-align: bottom;
      font-family: 'Roboto Mono';
      color #686868
  .box {
    display: flex;
    align-items: center
    cursor: pointer
    &:hover {
      background-color: #f5f5f5;
    }
    .remove {
      display: block
      color #888888
      margin-left 15px
    }
  }
  .image {
    width: 30px;
    margin-right: 20px;
  }
  .content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex 1
    text-align: left
    margin-bottom 0px
    strong {
      font-family: 'Azeret Mono', monospace;
      font-weight: 300
    }
    .long {
      display: block;
    }
    .medium {
      display: none;
    }
    .short {
      display: none;
    }
  }


@media (max-width: 450px)
  .big-info.main .pay-block button, .big-info.main .confirm-pay-block button
    margin-bottom: 5px;
  .big-info.main .big-info-number b
    font-size: 45px
  .big-info.main .big-info-number .count-up-balance
    font-size: 45px
  .table-payments td.amount, .table-reward-stats td.amount
    font-size: 18px;
  .big-info .big-info-number span
    margin-bottom: 10px;
  .min-height-balance
    min-height: initial;
    line-height initial;
    padding 5px 0px

@media (max-width: 575px)
  .balance-container
    .qr-container
      padding-bottom 20px
  .button-generate
    top 35%
  .current-address-view span.address_copy_
    display inline

@media (max-width: 913px)
  .big-info.main .pay-block button, .big-info.main .confirm-pay-block button
    margin-bottom: 5px;

@media (max-width: 768px)
  .address-search-field
    max-width 100%
  .prev-address
    width 100%

.start-info
  padding 10px 0px
  .title-mining
    font-size: 2.1rem;
    margin-bottom: 5px;
    font-weight: 600;
    span, img
      vertical-align: middle;
    .coin-symbol
      font-weight 700
    img
      margin: 0px 10px;
      width: 28px;
      min-width: 28px;
      display: inline-block;
      vertical-align: middle;
  .info-block
    font-size 14px

html.dark, body.dark
  .filter-label
    color #fff
  .button-back-search
    color #fff
    background #4a4a4a
    border-color #4a4a4a
    &.quick-search.loading-quick
      background #747474
      input
        background #747474
    .search-icon.searching
      color #fff
    input
      background #4a4a4a
      color #fff
      &::placeholder
        color #8b8b8b
  .confirm-block-network
    color #4a4a4a
    .cancel-confirm-network
      color #4a4a4a
  .count-up-balance
    color #fff !important;
  .prev-label, .start-info .title-mining
    color #fff
  .prev-address .box
    background #000
    .content .long
      color #fff
    .content
      .content-balance, .content-last
        color #fff
  .reload-control
    color #fff
  .newest-list
    .new-coin-loading
      color #fff
  .newest-list .new-coin:not(.view-all)
    background: #4a4a4a;
  .newest-list .new-coin .new-tag
    color: #000;
  .new-coin-separator
    background #808080
  .recent-item-el
    color #fff
</style>



// WEBPACK FOOTER //
// View_Stats.vue?a58a17d4